import { h, render } from 'preact'; // eslint-disable-line no-unused-vars

export const LevelIcon = () => (
  <div className="level-icon icon-wrapper">
    <svg className="icon icon_level" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
      <path d="M30,0H22.49V7.5H15V15H7.5v7.5H0V30H30Z"/>
    </svg>
  </div>
);

export default () => {
  [...document.getElementsByTagName('LevelIcon')].forEach((el) => {
    render(LevelIcon, el, LevelIcon.children);
  });
};
